import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import Tooltip from '@material-ui/core/Tooltip'
import { HistoryDialog, DeleteDialog } from '../Dialogs'
import EditButton from './EditButton'
import ShowButton from './ShowButton'

const styles = {
    container : {
        width : 80,
        display : 'flex',
        justifyContent : 'space-evenly',
        '& button' : {
            width: 20,
            height: 20,
            '& svg' : {
                fontSize : 18
            }
        }
    },
}

const RowActions = (props) => {
    if (props.permissions === null) {
        return null
    }
    const { basePath, record, resource, permissions: { role, empresas } } = props
    const { classes, ...rest } = props
    const relatedEmpresas = Object.keys(empresas)

    const editButton = (
        <Tooltip title="Editar">
            <EditButton basePath={basePath} record={record}/>
        </Tooltip>
    )
    const showButton = (
        <Tooltip title="Ver">
            <ShowButton basePath={basePath} record={record}/>
        </Tooltip>
    )
    const historyButton = (
        <Tooltip title="Historial de Cambios">
            <HistoryDialog {...rest}/>
        </Tooltip>
    )
    const deleteButton = (
        <Tooltip title="Eliminar">
            <DeleteDialog {...rest}/>
        </Tooltip>
    )

    if (role === "admin" || role === "coordinador") {
        return (
            <div className={classes.container}>
                {showButton}
                {editButton}
                {historyButton}
                {deleteButton}
            </div>
        )
    } else if (role === "externo") {
        return (
            <div className={classes.container}>
                {showButton}
                {editButton}
                {historyButton}
            </div>
        )
    } else if (role === "coordinado") {
        if (resource === "empresas" && relatedEmpresas.includes(record.id)) {
            return (
                <div className={classes.container}>
                    {showButton}
                    {empresas[record.id].permissions.includes("edit") && editButton}
                    {empresas[record.id].permissions.includes("read") && historyButton}
                    {empresas[record.id].permissions.includes("delete") && deleteButton}
                </div>
            )
        } else if (relatedEmpresas.includes(record.propietario.id)) {
            return (
                <div className={classes.container}>
                    {showButton}
                    {empresas[record.propietario.id].permissions.includes("edit") && editButton}
                    {empresas[record.propietario.id].permissions.includes("read") && historyButton}
                    {empresas[record.propietario.id].permissions.includes("delete") && deleteButton}
                </div>
            )
        } else {
            return null
        }
    } else if (role === "guest"){
      return (
        <div className={classes.container}>
          {showButton}
          {historyButton}
        </div>
      )
    }
}

export default withStyles(styles)(RowActions)
